import { CommonModule, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import {
  ClientEnvironment,
  CommonUtilityLib,
  ENVIRONMENT,
  NavigationItem,
  RouterHistoryService,
  StorageUtilityLib,
  USER_SESSION_TOKEN,
  UserData,
  UserSession,
} from '@thehubz/client/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sp-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
})
export class PageTitleComponent implements OnInit, OnDestroy {
  private headerTextSub?: Subscription;

  headline?: string;
  subHeadline?: { id: string; name: string };
  headerLink?: string;
  routingObject: NavigationItem = {} as NavigationItem;
  historyObject: AnyType;
  loggedInUser!: UserInfo;
  impersonated?: UserInfo;
  brandingKey!: string;
  hasBackLink!: boolean;

  constructor(
    private commonUtilityLib: CommonUtilityLib,
    private router: Router,
    private storageUtility: StorageUtilityLib,
    private location: Location,
    private routerHistoryService: RouterHistoryService,
    @Inject(ENVIRONMENT) protected readonly env: ClientEnvironment,
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
  ) {}

  ngOnInit(): void {
    this.brandingKey = this.env.brandingKey;
    this.hasBackLink = this.router.url.includes('/assets/detail/') || this.router.url.includes('/collections/collection-asset-list/');

    this.router.events.subscribe((event: AnyType) => {
      if (event instanceof NavigationEnd) {
        this.hasBackLink = event.url.includes('/assets/detail/') || this.router.url.includes('/collections/collection-asset-list/');
      }
    });

    const userSession = this.storageUtility.getLocalStorage<UserSession>(this.userSessionToken);

    this.headerTextSub = this.commonUtilityLib.headerText$.subscribe((res) => {
      if (res) {
        this.headline = res.header;
        this.subHeadline = res.subHeader;
        this.headerLink = res.routeLinkPath;
      } else {
        this.headline = undefined;
        this.subHeadline = undefined;
        this.headerLink = undefined;
      }
    });

    this.routingObject = this.commonUtilityLib.routingObjectGetter();

    const asUserInfo = (userData: UserData) => ({
      id: userData._id,
      name: userData.firstName + ' ' + userData.lastName,
      email: userData.email,
    });

    this.loggedInUser = asUserInfo(userSession.userData);
    if (userSession.userData.impersonate) {
      this.impersonated = asUserInfo(userSession.userData.impersonate);
    }
  }

  navUrl(url: string[]) {
    this.commonUtilityLib.routingObjectSetter(this.historyObject);
    this.router.navigate(url);
  }

  ngOnDestroy(): void {
    if (this.headerTextSub) this.headerTextSub.unsubscribe();
  }

  navBack(): void {
    this.location.back();
  }

  onBackClick(): void {
    this.router.navigateByUrl(this.routerHistoryService.assetBackDestination);
  }
}
